module.exports = __webpack_public_path__ + "img/conny-f-stage1-hungry.9b9741b9.png";